module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/2-0c37a57cfeb7f1acec018e30b210f8dc.jpg";